const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

function endOfLocalDay(dateOnly) {
  const [year, month, day] = dateOnly.slice(1).map(Number);
  const limit = new Date(year, month - 1, day, 23, 59, 59, 999);

  // O construtor não recusa dia ou mês fora da faixa, ele rola o excedente: '2026-11-31' viraria
  // 01/12 e passaria como data válida.
  const isSameDay =
    limit.getFullYear() === year && limit.getMonth() === month - 1 && limit.getDate() === day;

  return isSameDay ? limit : new Date(NaN);
}

/**
 * `expiresAt` só com a data vale até o fim desse dia no horário de quem vê. Não dá para usar
 * `new Date('2026-11-30')`: o JS lê data sem hora como meia-noite UTC, e no Brasil o aviso sumiria
 * às 21h do dia anterior. Data com hora segue o instante que ela diz.
 *
 * Data inválida conta como expirada: um erro de digitação deixaria o aviso no ar para sempre, e é
 * mais fácil notar o aviso que não apareceu.
 */
export default function isAnnouncementExpired(expiresAt, now = new Date()) {
  if (!expiresAt) return false;

  const dateOnly = typeof expiresAt === 'string' && expiresAt.match(DATE_ONLY);
  const limit = dateOnly ? endOfLocalDay(dateOnly) : new Date(expiresAt);

  if (Number.isNaN(limit.getTime())) return true;

  return now.getTime() > limit.getTime();
}
